import { InjectionToken } from '@angular/core';

/**
 * The payload a Clarity overlay's body component was opened with.
 *
 * One token for both primitives, so a body can move between a dialog and a fly-in without changing
 * how it reads its data. It is deliberately **not** `MAT_DIALOG_DATA`: a body that injected the
 * Material token would couple every ported screen to `@angular/material`, and the whole point of
 * this library is that the coupling stops at `ClarityDialog`.
 *
 * Typed `unknown` because the token is shared by every overlay in the application; the body narrows
 * it at the injection site — `inject<ApprovalPanelData>(CLARITY_OVERLAY_DATA_TOKEN)`.
 */
export const CLARITY_OVERLAY_DATA_TOKEN = new InjectionToken<unknown>('CLARITY_OVERLAY_DATA');
